import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE, absoluteUrl } from "../config/site";

/**
 * Per-route SEO. Uses react-helmet-async (client-side meta updates).
 * Best long-term SEO: consider Next.js SSR/SSG; this wraps CRA with strong on-page fundamentals.
 */
export default function PageSEO({
  title,
  description,
  keywords,
  path = "/",
  type = "website",
  image,
  noindex = false,
  article,
}) {
  const fullTitle = title.includes(SITE.name) ? title : `${title} | ${SITE.name}`;
  const canonical = absoluteUrl(path);
  const ogImage = image || SITE.ogImage;

  return (
    <Helmet prioritizeSeoTags>
      <html lang="en" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}

      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      {article?.publishedTime ? (
        <meta property="article:published_time" content={article.publishedTime} />
      ) : null}
      {article?.modifiedTime ? (
        <meta property="article:modified_time" content={article.modifiedTime} />
      ) : null}
    </Helmet>
  );
}
